<template>
  <div class="grid gap-24">
    <!--<p>Värdera</p>
    <BuybackBanner
      v-if="store.fetchedData.buybackIsEnabled"
      :data="{
        valuateOnly: true,
        type: 'valuate',
      }"
    ></BuybackBanner>-->
    <BuybackMainContainer
      v-if="store.fetchedData.buybackIsEnabled"
      :data="{
        type: 'toProduct',
        valuateOnly: false,
        selectedProductId: firstBundleItem?.Id ?? null,
        selectedManufacturer: firstBundleItem?.ManufacturerName ?? null,
        selectedPlanId: firstBundleItem?.BundlePlanItem?.Id ?? null,
        downPaymentTime: store.userState.payment.selectedDownPayTime,
        orderNumber: null,
      }"
    />

    <CheckoutDiscountCode />
    <GlobalNotificationContainer
      :show="!!notifications.title"
      :is-just-text-row="true"
    />
    <form class="w-full" novalidate @submit.prevent="onClickNextStep">
      <CheckoutNextStepButton> Gå vidare </CheckoutNextStepButton>
    </form>
  </div>
</template>

<script lang="ts" setup>
import type { ShoppingCartItemModel } from '~/models/shopping_cart/ShoppingCartItem.api.model';
const store = useMyCheckoutStore();
const notifications = useNotificationStore();

const firstBundleItem = store.fetchedData.cart.cartItems.find(
  (item: ShoppingCartItemModel) => item.Category === 'Mobiler',
);

onMounted(() => {
  const { pushBeginCheckoutEvent } = useGoogleAnalyticsEvents();
  pushBeginCheckoutEvent(store.trackingData);
});
const onClickNextStep = () => {
  notifications.reset();
  store.goToNextStep();
};
</script>

<style lang="scss" scoped>
.step-button-container {
  padding-top: 2.4rem;
  max-width: 38.3rem;
  margin: 0 auto;
}
</style>
